<script setup>
import {ref} from "vue";
import CreateHpoModal from "./CreateHpoModal";
import HpoListQuery from "@/graphql/queries/hpo/hpoList.graphql"
import HpoTestPasswordQuery from "@/graphql/queries/hpo/testPassword.graphql"
import {useMutation, useQuery} from "@vue/apollo-composable";
import {useLastResult} from "@/graphql/composable";
import App from "@/components/App";
import {currentUser} from "@/infrastructure/user";
import DeleteHpoMutation from "@/graphql/mutations/hpo/deleteHpo.graphql"
import {Permissions} from "@/infrastructure/permissions";
import QRmodal from "./dashboard/QRmodal.vue";
import {mdiTrashCanOutline} from "@mdi/js";

const showCreateModal = ref(false)

const {result, loading: hpoListLoading} = useQuery(HpoListQuery)
const hpoList = useLastResult(result, [], data => data.hpoList)
const {mutate} = useMutation(DeleteHpoMutation, {
  update: (cache, {data: {deleteHpoMutation}}) => {
    const normalizedId = cache.identify({id: deleteHpoMutation.hpoId, __typename: 'HpoObjectType'})
    cache.evict({id: normalizedId})
  }
})

const {result: testPasswordResult, loading: testPasswordLoading} = useQuery(HpoTestPasswordQuery);
const testPassword = useLastResult(testPasswordResult, null, data => data.hpoTestPassword);

function deleteMci(hpoId) {
  if (confirm(gettext('Are you sure you want to delete this MCI?'))) {
    mutate({id: hpoId})
  }
}

const CREATE_TEST_CASE_URL = document.location.origin + '/hpo-edu'
const showQRModal = ref(false)
</script>

<template>
  <App>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" class="d-flex flex-column ga-5">
          <!--                    <v-card color="deep-orange-lighten-4">-->
          <!--                        <v-card-title>-->
          <!--                            {{ pgettext('title', 'Test case') }}-->
          <!--                        </v-card-title>-->
          <!--                        <v-card-text class="font-weight-bold">-->
          <!--                            <div>-->
          <!--                                <span class="mr-2">{{ pgettext('title', 'address') }}:</span>-->
          <!--                                <a :href="CREATE_TEST_CASE_URL">{{ CREATE_TEST_CASE_URL }}</a>-->
          <!--                            </div>-->
          <!--                            <div>-->
          <!--                                <span class="mr-2">{{ pgettext('title', 'password') }}:</span>-->
          <!--                                <span v-if="!testPasswordLoading">{{ testPassword }}</span>-->
          <!--                                <div v-else class="d-inline-block">-->
          <!--                                    <v-progress-circular indeterminate :size="12" :width="2"/>-->
          <!--                                </div>-->
          <!--                            </div>-->
          <!--                        </v-card-text>-->
          <!--                        <v-card-actions>-->
          <!--                            <v-btn :prepend-icon="mdiQrcodeScan"-->
          <!--                                   :text="pgettext('action', 'Show QR code')"-->
          <!--                                   @click="showQRModal=true"-->
          <!--                                   variant="elevated"-->
          <!--                                   block-->
          <!--                            ></v-btn>-->
          <!--                        </v-card-actions>-->
          <!--                    </v-card>-->
          <v-card :title="pgettext('title', 'MCI List')" :loading="hpoListLoading">
            <v-card-text>
              <v-list variant="tonal" v-if="hpoList.length > 0">
                <v-list-item
                  v-for="hpo in hpoList"
                  :key="hpo.id"
                  :to="{name: 'hpo:dashboard', params: {id: hpo.id}}"
                  :title="hpo.name">
                  <template v-slot:append>
                    <v-btn v-if="parseInt(hpo.createdBy.id) === currentUser.id"
                           color="red"
                           @click.prevent="deleteMci(hpo.id)"
                           :text="pgettext('action', 'delete')"
                           :icon="mdiTrashCanOutline"
                           variant="text"
                           block
                    ></v-btn>
                  </template>
                </v-list-item>
              </v-list>
              <v-alert v-else
                       :text="gettext('There are currently no active MCI cases for your workplace')"
                       :title="pgettext('title', 'No active MCIs for your workplace')"
                       type="info"
                       variant="tonal"
              ></v-alert>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="currentUser.hasPermission(Permissions.HPO__CREATE)"
                     @click="showCreateModal=true"
                     :text="pgettext('label', 'Create new MCI')"
                     variant="elevated"
                     block
              ></v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <CreateHpoModal v-if="showCreateModal"
                    @close="showCreateModal=false"/>
    <QRmodal v-if="showQRModal"
             :url="CREATE_TEST_CASE_URL"
             :testPassword="testPassword"
             @close="showQRModal=false"/>
  </App>
</template>